import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Space, Spin, Typography } from "antd";
import { useAgentEntitlements } from "./useAgentEntitlements";
import { isAdminUser } from "../../services/authService";
import { navigateAgentPackageUpgrade } from "../../utils/agentUpgradeNavigation";

const { Title, Paragraph } = Typography;

/**
 * SSOT: package_feature_values via POST /api/agents/me/entitlements.
 * @param {string} featureKey - backend feature_key (e.g. leads_system, crazy_llama)
 * @param {React.ReactNode} children
 * @param {string} [title]
 * @param {string} [description]
 */
export function EntitlementGate({
  featureKey,
  children,
  title = "הפיצ׳ר זמין בחבילה מתקדמת יותר",
  description = "שדרגו את החבילה בכדי לקבל גישה.",
  upgradeButtonText = "שדרוג חבילה",
}) {
  const navigate = useNavigate();
  const { status, loading, refresh, canUseFeature } = useAgentEntitlements();
  const allowed = canUseFeature(featureKey);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const onUpgrade = useCallback(() => {
    if (isAdminUser()) {
      navigate("/p/dashboard/admin/package-features");
      return;
    }
    navigateAgentPackageUpgrade(navigate, "entitlement_gate");
  }, [navigate]);

  if ((loading || status === "idle") && !allowed) {
    return (
      <div style={{ padding: 48, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!allowed) {
    return (
      <div style={{ padding: 16 }}>
        <Card>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Title level={4} style={{ margin: 0 }}>
              {title}
            </Title>
            <Paragraph style={{ marginBottom: 0 }}>{description}</Paragraph>
            <Button type="primary" onClick={onUpgrade}>
              {upgradeButtonText}
            </Button>
          </Space>
        </Card>
      </div>
    );
  }

  return children;
}
